import React, { FC } from 'react';

import { StockModelCardCaptionProps } from '.';
import useTranslations from '@hooks/useTranslations';

export const StockModelCardCaptionTemplate: FC<StockModelCardCaptionProps> = ({
    className,
    isColorAndInteriorDisplayed,
    color,
    interior,
    imageUrl,
    imageAlt,
}) => {
    const { t } = useTranslations();

    return (
        <figure className={`${className} stockModelCard-imageContainer`}>
            <img src={imageUrl} alt={imageAlt ?? 'psa car'} className="stockModelCard-imageContainer--image" />
            {isColorAndInteriorDisplayed && (
                <figcaption className="stockModelCard-imageContainer--info">
                    <dl className="stockModelCard-imageContainer--info__list">
                        {color && (
                            <>
                                <dt className="highlighted-text">{t('stockModelCard.color')}:</dt>
                                <dd>{color}</dd>
                            </>
                        )}

                        {interior && (
                            <>
                                <dt className="highlighted-text">{t('stockModelCard.interior')}:</dt>
                                <dd>{interior}</dd>
                            </>
                        )}
                    </dl>
                </figcaption>
            )}
        </figure>
    );
};

export default StockModelCardCaptionTemplate;
